/* eslint-disable @typescript-eslint/no-explicit-any */
import { trimObjectValues } from '@helpers/objectHelper';
import { updateGeotabSourceCookie } from '@helpers/geotabSourceCookieHelper';
import { httpPost } from './apiService';
import { FormService } from '@models/form';

export async function postForm(
    formService: FormService,
    formId: string,
    jsonData: Record<string, any>,
    recaptchaToken: string,
    marketoFormId?: string
): Promise<void> {
    const modifiedFormValues: Record<string, any> = { ...trimObjectValues(jsonData) };
    modifiedFormValues.recaptchaToken = recaptchaToken;

    if (formId === 'generic-lead-form-test' || formId === 'generic-lead-form') {
        const geotabSourceCookieValue = updateGeotabSourceCookie();

        modifiedFormValues['Website_Cookie__c'] = geotabSourceCookieValue
            ? Object.keys(geotabSourceCookieValue)
                .map((key) => `${key}:${geotabSourceCookieValue[key as keyof typeof geotabSourceCookieValue]}`)
                .join()
            : '';
    }

    // Determine the endpoint based on the form service and whether a marketoFormId is provided
    let endpoint = `/api/${formService}/`;
    if (formService === FormService.Marketo) {
        if (marketoFormId) {
            endpoint += `${marketoFormId}/`;
        }
    } else {
        endpoint += `${formId}/`;
    }

    await httpPost(endpoint, JSON.stringify(modifiedFormValues));
}
